import { PureDataMarkerProps } from '@weenat/client/dist/core/map'
import { BoxProps } from 'app/src/kit/primitives/themeMappings/props'
import { memo } from 'react'
import PureDataMarker from './PureDataMarker'

interface RestrictedDataMarkerProps {
  type: PureDataMarkerProps['type']
  isFocused?: PureDataMarkerProps['isFocused']
  boxShadow?: BoxProps['$boxShadow']
  hideAnchor?: PureDataMarkerProps['hideAnchor']
}

/**
 * Restricted marker — shown when the resource's data is inaccessible due to
 * subscription limits. Renders as a white marker with a lock badge.
 */
const RestrictedDataMarker: FC<RestrictedDataMarkerProps> = ({
  type,
  isFocused,
  boxShadow,
  hideAnchor
}) => (
  <PureDataMarker
    backgroundColor='grayscale.100'
    color='black'
    content={null}
    trend={undefined}
    showLastUpdate={false}
    lastUpdate={undefined}
    showStatusIndicator
    status='restricted'
    type={type}
    showContent={false}
    isFocused={isFocused}
    boxShadow={boxShadow}
    hideAnchor={hideAnchor}
    timezone={undefined}
  />
)

export default memo(RestrictedDataMarker)
